// Template
import template from './fixed-widget.vhtml';

import Share from '../share/share.js';

export default {
    template: template,
    components: {
        Share
    },
}


// WEBPACK FOOTER //
// ./assets/_js/components/fixed-widget/fixed-widget.js